import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { ArrowRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { useSite } from "../context/SiteContext";
import { img } from "../lib/images";

export const Journey = () => {
  const { journey: j } = useSite();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section id="journey" ref={ref} data-testid="journey-section" className="bg-mint/60 py-24 sm:py-32">
      <div className="mx-auto grid max-w-7xl items-center gap-12 px-5 sm:px-8 lg:grid-cols-2 lg:gap-20">
        <Reveal>
          <div className="relative h-[420px] overflow-hidden rounded-[28px] sm:h-[560px]">
            <motion.img style={{ y, scale: 1.18 }} {...img("terrace", "(min-width: 1024px) 50vw, 100vw")} loading="lazy" decoding="async" alt="Rice terraces in Bali" className="absolute inset-0 h-full w-full object-cover" />
          </div>
        </Reveal>
        <div>
          <Reveal>
            <Eyebrow>Our Journey</Eyebrow>
            <h2 className="font-display text-4xl leading-[1.08] text-ink sm:text-5xl">{j.title}<br /><em className="text-clay">{j.highlight}</em></h2>
            <p className="mt-6 max-w-lg text-base leading-relaxed text-ink/70 sm:text-lg">
              {j.text}
            </p>
          </Reveal>
          <ol className="mt-10 border-t border-ink/15">
            {j.milestones.map((m, i) => (
              <Reveal key={i} delay={i * 0.08}>
                <li className="grid grid-cols-[110px_1fr] gap-4 border-b border-ink/15 py-5" data-testid={`milestone-${i}`}>
                  <span className="font-display text-2xl text-clay">{m.year}</span>
                  <span className="self-center text-ink/80">{m.text}</span>
                </li>
              </Reveal>
            ))}
          </ol>
          <Reveal delay={0.2}>
            <a href="#contact" className="btn-primary group mt-10" data-testid="journey-cta-btn">
              Work with us <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
